import { render, staticRenderFns } from "./SharePage.vue?vue&type=template&id=5949e5e1&"
import script from "./SharePage.vue?vue&type=script&lang=js&"
export * from "./SharePage.vue?vue&type=script&lang=js&"
import style0 from "./SharePage.vue?vue&type=style&index=0&id=5949e5e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports